import { FC } from 'react'
import useSingleBroadcast from 'hooks/useSingleBroadcast'
import { RiCheckFill } from 'react-icons/ri'
import { Typography } from 'antd'

import styles from './styles.module.scss'

const { Title } = Typography

interface PanelHeaderProps {
	title: string
	panelKey: number
	activeKey: number
	// activeKey: number
}

const PanelHeader: FC<PanelHeaderProps> = ({ panelKey, activeKey, title }) => {
	const { broadcast } = useSingleBroadcast()

	const currentStep = broadcast?.currentStep || 1
	const completed = currentStep > panelKey

	return (
		<div className={styles.broadcastForm_templateHeader}>
			<span
				className={`${styles.broadcastForm_templateHeader_key}${
					activeKey === panelKey
						? ` ${styles.broadcastForm_templateHeader_key_active}`
						: ''
				}${
					completed ? ` ${styles.broadcastForm_templateHeader_key_complete}` : ''
				}`}
			>
				{completed ? <RiCheckFill /> : panelKey}
			</span>
			<Title className={styles.broadcastForm_templateHeader_title} level={4}>
				{title}
			</Title>
		</div>
	)
}

export default PanelHeader
